var TabPreferencesModule = /** @class */ (function () {
    function TabPreferencesModule() {
    }
    return TabPreferencesModule;
}());
export { TabPreferencesModule };
